import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { PUBLIC_ROUTE } from '@/constants'
import { AuthState } from '@/state'

export const PrivateRoute: React.FC = () => {
  if (AuthState.isLoggedIn.value) return <Outlet />

  return <Navigate replace to={PUBLIC_ROUTE.SIGN_IN} />
}
